// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import { filterRecord, filterUserRecords } from 'services/filter';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    setSystemLoadingAction,
    SetSystemLoadingAction,
} from 'store/actions/errorsActions';
import {
    SetFavouritControlsAction,
    setFavouritControlsAction,
    SetHighlightObjectAction,
    setHighlightObjectAction,
    setLayoutAction,
    SetLayoutAction,
    setSearchObjectAction,
    SetSearchObjectAction,
} from 'store/actions/layoutActions';
import { OpenModal, PortType, RootState, UserType } from 'types';
import {
    ClearLodedFilterInterface,
    GetLodedFilterInterface,
    LoadSavedFiltersInterface,
    SearchControlsInterface,
} from 'types/functions';
import { FilterObjectType, FilterType } from 'types/search';
import { SummaryData, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { clone } from 'utils/formHandlers';
import { formatSavedFilter } from 'utils/migrations';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';
import ResultMessage from './filter/ResultMessage';

interface FavouritMenuComponentProps {
    active: boolean;
    system: SystemType;
    port: PortType;
    setLayoutAction: SetLayoutAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setFavouritControlsAction: SetFavouritControlsAction;
    setSearchObjectAction: SetSearchObjectAction;
    setHighlightObjectAction: SetHighlightObjectAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    searchControls: SearchControlsInterface;
    openModelFunction: OpenModal;
    dateTimeFormat: DateTimeFormat;
    user: UserType;
    searchObject: FilterObjectType;
}

interface FavouritMenuComponentState {
    active: boolean;
    foundNumbers: SummaryData | null;
    searchNumbers: SummaryData | null;
    initialumbers: SummaryData;
    savedFilters: FilterType[];
    filter: FilterType | null;
    loading: boolean;
    searchObject: FilterObjectType;
}

class FavouritMenu extends Component<FavouritMenuComponentProps, FavouritMenuComponentState> {
    constructor(props: FavouritMenuComponentProps) {
        super(props);
        this.state = {
            initialumbers: {
                total: props.system.transits.total,
                inDateRangeForReview: props.system.transits.forReview,
                inDateRange: props.system.transits.total,
                forReview: props.system.transits.forReview,
                ppu: props.system.transits.ppu,
                simulated: props.system.transits.simulated,
                endDate: props.system.date.endDate.clone(), //clone from system start date
                startDate: props.system.date.startDate.clone(), //clone from system end date
                time: this.props.dateTimeFormat.parseDateTime(null, 'initialum time'),
            },
            foundNumbers: null,
            searchNumbers: null,
            active: props.active,
            savedFilters: [],
            filter: null,
            loading: false,
            searchObject: clone(props.searchObject),
        };
    }

    static getDerivedStateFromProps(props: FavouritMenuComponentProps, state: FavouritMenuComponentState) {
        if (props.active !== state.active) {
            return { active: props.active };
        }
        return null;
    }

    componentDidMount(): void {
        this.loadSavedFilters(0);

        this.props.setFavouritControlsAction({
            getLodedFilter: this.getLodedFilter,
            clearLodedFilter: this.clearLodedFilter,
            loadSavedFilters: this.loadSavedFilters,
        });
    }

    componentDidUpdate(prevProps: FavouritMenuComponentProps, prevState: FavouritMenuComponentState) {
        if (prevState.active !== this.state.active && this.state.active) {
            this.setState({
                foundNumbers: this.props.searchControls.getFoundObjectNumbers(),
                searchNumbers: this.props.searchControls.getSearchObjectNumbers(),
            });
        }
    }
    getLodedFilter: GetLodedFilterInterface = () => {
        return this.state.filter;
    };

    loadSavedFilters: LoadSavedFiltersInterface = (id) => {
        filterUserRecords(this.props.port.id, {})
            .then((res) => {
                const selectedFilter = res.items.find((x) => {
                    return x.id === id;
                });

                this.setState({
                    filter: id ? (selectedFilter ? selectedFilter : null) : null,
                    savedFilters: res.items,
                });
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    };

    loadSavedFilter = (id, edit = false) => {
        filterRecord(this.props.port.id, id)
            .then((res) => {
                this.setState(
                    {
                        filter: res.items,
                        loading: true,
                    },
                    () => {
                        this.props.setSearchObjectAction(
                            formatSavedFilter(this.props.dateTimeFormat, res.items.filter)
                        );
                        setTimeout(async () => {
                            const foundNumbers = await this.props.searchControls.runGetSearchNumbers(false);
                            this.setState({ foundNumbers, loading: false });
                            if (edit) {
                                this.edit();
                            }
                        }, 1000);
                    }
                );
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    };

    clearLodedFilter: ClearLodedFilterInterface = () => {
        this.setState({
            filter: null,
        });
    };

    edit = () => {
        this.props.openModelFunction(
            'saveSearchModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('saveSearchModel');
                },
            },
            true
        );
    };

    delete = (id, name) => {
        this.props.openModelFunction(
            'deleteSearchModel',
            0,
            'medium',
            { id: id, name: name },
            {
                onCancel: () => {
                    this.props.openModelFunction('deleteSearchModel');
                },
            }
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">{translate('Favourite search')}</div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'favouritMenu',
                                        section: 'grid',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'favouritMenu',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'favouritMenu',
                                        section: 'profile',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>
                <div className={twclsx(!this.state.active && 'hidden')}>
                    <ResultMessage
                        display="search"
                        limit={this.state.searchObject.limit}
                        isLoading={this.state.loading}
                        isFoundResults={this.state.foundNumbers !== null}
                        isSearchResults={this.state.searchNumbers !== null}
                        foundNumbers={this.state.foundNumbers}
                        initialumbers={this.state.initialumbers}
                        searchNumbers={this.state.searchNumbers}
                    >
                        <div className="  w-full  h-10 pt-3 justify-end  flex gap-2">
                            <Button
                                onClick={() => {
                                    // this.props.setLayoutAction([
                                    //     {
                                    //         action: 'UPDATE_MENU',
                                    //         data: {
                                    //             name: 'searchMenu',
                                    //             section: 'chart',
                                    //             state: false,
                                    //         },
                                    //     },
                                    // ]);
                                    //@ts-ignore
                                    this.props.searchControls.search(this.state.filter?.highlight.status);
                                }}
                                type="button"
                                disabled={this.state.loading || !this.state.filter}
                                className={twclsx(
                                    'px-4',
                                    'h-5',
                                    'w-16',
                                    this.state.loading ? 'bg-gray-300 ' : 'bg-primary-300 ',
                                    'rounded-md',
                                    'px-3',
                                    'rounded',
                                    'text-white'
                                )}
                            >
                                {translate('load')}
                            </Button>

                            <Button
                                onClick={() => {
                                    this.setState(
                                        { foundNumbers: null, searchNumbers: null },

                                        this.props.searchControls.clear
                                    );
                                }}
                                type="button"
                                disabled={!this.state.filter}
                                className="px-4 py-2 h-5 w-16 bg-primary-300 rounded-md text-white"
                            >
                                {translate('clear')}
                            </Button>
                        </div>
                    </ResultMessage>
                    <Scrollbars autoHide className={twclsx('h-search', 'w-full', 'pr-1', 'mt-2')}>
                        <div className="mx-2 flex mt-2 flex-col gap-1">
                            {this.state.savedFilters.map((x) => {
                                return (
                                    <div className="flex justify-between" key={x.id}>
                                        <div>
                                            <div
                                                onClick={() => {
                                                    this.loadSavedFilter(x.id);
                                                }}
                                                className={twclsx(
                                                    x.id === this.state.filter?.id && 'text-primary-300',
                                                    'font-bold',
                                                    'cursor-pointer',
                                                    'flex'
                                                )}
                                            >
                                                <div>{x.name}</div>
                                                {x.type === 'system' && (
                                                    <Icon className="w-3 h-3 ml-1 mt-1 text-black">
                                                        <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                                                        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                                                    </Icon>
                                                )}
                                            </div>
                                            <div className="text-sm text-gray-300">
                                                {this.props.dateTimeFormat
                                                    .parseDateTime(x.updated_at)
                                                    .formatDateTimeToString('dd LLL yyyy')}
                                            </div>
                                        </div>
                                        {x.user_id === this.props.user.id && (
                                            <div className="flex gap-2">
                                                <div
                                                    onClick={() => {
                                                        this.loadSavedFilter(x.id, true);
                                                    }}
                                                >
                                                    <Icon className="w-4 h-4 mt-2 cursor-pointer">
                                                        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                                                        <path d="M13.5 6.5l4 4"></path>
                                                        <path d="M16 19h6"></path>
                                                    </Icon>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        this.delete(x.id, x.name);
                                                    }}
                                                >
                                                    <Icon className="w-4 h-4 mt-2 cursor-pointer text-primary-delete">
                                                        <path d="M4 7l16 0"></path>
                                                        <path d="M10 11l0 6"></path>
                                                        <path d="M14 11l0 6"></path>
                                                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                                    </Icon>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </Scrollbars>
                </div>
            </div>
        );
    }
}

const favouritmenuStateToProps = (state: RootState) => ({
    port: state.port.port,
    system: state.port.system,
    user: state.user.user,
    searchControls: state.layout.searchControls,
    openModelFunction: state.layout.openModelFunction,
    dateTimeFormat: state.port.dateTimeFormat,
    searchObject: state.layout.searchObject,
});

const favouritmenuDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setSearchObjectAction: bindActionCreators(setSearchObjectAction, dispatch),
    setHighlightObjectAction: bindActionCreators(setHighlightObjectAction, dispatch),
    setFavouritControlsAction: bindActionCreators(setFavouritControlsAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(favouritmenuStateToProps, favouritmenuDispatchToProps)(FavouritMenu);
